








































































































import Vue from 'vue'
import ModalRequestLogin from '@/stockLibrary/components/ModalRequestLogin.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import ModalSelectStockLibraryDesign from '@/common/components/StockLibrary/ModalSelectStockLibraryDesign.vue'
import ModalUploadImage from '@/stockLibrary/components/AddNewImage.vue'

import { DesignImage } from '@/stockLibrary/queries/types'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { createUserDesign } from '@/stockLibrary/services'
import { BQ_EVENT_NAMES, raksulBQEventTracker, EVENT_CATEGORIES, gaEventTracker, EVENT_ACTIONS, EVENT_LABELS } from '@/common/utils'

export default Vue.extend({
  components: {
    ModalRequestLogin,
    BaseImage,
    ModalSelectStockLibraryDesign,
    ModalUploadImage
  },
  props: {
    designImages: {
      type: Array as () => DesignImage[],
      required: true
    },
    defaultTransparent: {
      type: Boolean,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  data(): {
    showRequestLoginModal: boolean
    showSelectDesignModal: boolean
    showAddNewImageModal: boolean
    isTransparent: boolean
    userDesigns: DesignImage[]
    selectedDesignImage: DesignImage | undefined
  } {
    return {
      showRequestLoginModal: false,
      showSelectDesignModal: false,
      showAddNewImageModal: false,
      isTransparent: this.defaultTransparent,
      userDesigns: [],
      selectedDesignImage: this.designImages[0]
    }
  },
  computed: {
    isMobileView(): boolean {
      return window.innerWidth <= 1024
    },
    squareImagePlaceholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    displayDesignImages(): DesignImage[] {
      return this.userDesigns.slice(0, this.isMobileView ? 4 : 6)
    },
    disabledTransparentPreview(): boolean {
      return !this.selectedDesignImage?.transparentVersion?.uuid
    },
    previewDesignUrl(): string {
      return this.isTransparent
        ? (this.selectedDesignImage?.transparentVersion?.imageUrl || '')
        : (this.selectedDesignImage?.nonTransparentVersion?.imageUrl || '')
    }
  },
  mounted() {
    this.userDesigns = [...this.designImages]

    const urlParams = new URLSearchParams(window.location.search)
    const designVersionUuid = urlParams.get('userDesignVersionUuid')

    if (!designVersionUuid) return
    const selectDesign = this.designImages.find(
      design => design.nonTransparentVersion?.uuid === designVersionUuid
        || design.transparentVersion?.uuid === designVersionUuid
      )
    if (selectDesign) {
      this.isTransparent = selectDesign.transparentVersion?.uuid === designVersionUuid
      this.onSelectDesign(selectDesign.uuid)
      this.switchPosition()
    }
  },
  methods: {
    informSelectedDesignChange() {
      const designVersionUuid = this.isTransparent
        ? this.selectedDesignImage?.transparentVersion?.uuid
        : this.selectedDesignImage?.nonTransparentVersion?.uuid
      const designVersionImageUrl = this.isTransparent
        ? this.selectedDesignImage?.transparentVersion?.imageUrl
        : this.selectedDesignImage?.nonTransparentVersion?.imageUrl

      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}?userDesignVersionUuid=${designVersionUuid}`
      )

      this.$emit('changeSelectedDesign', {
        designVersionUuid,
        designVersionImageUrl,
        isDefault: this.selectedDesignImage?.isDefault
      })
    },
    onSelectDesign(uuid: string) {
      const selectedDesign = this.userDesigns.find(item => item.uuid === uuid)

      if (!selectedDesign?.transparentVersion?.uuid && this.isTransparent) {
        this.isTransparent = false
      }
      this.selectedDesignImage = selectedDesign
      this.informSelectedDesignChange()
    },
    onConfirmSelectDesign(payload: { design: DesignImage, switchPosition: boolean }) {
      this.onSelectDesign(payload.design.uuid)
      this.showSelectDesignModal = false
      if (payload.switchPosition) {
        this.switchPosition()
      }
    },
    switchPosition(): void {
      const selectedDesignIdx = this.userDesigns.findIndex(
        item => item === this.selectedDesignImage
      )
      this.userDesigns.unshift(this.userDesigns.splice(selectedDesignIdx, 1)[0])
    },
    openSelectDesignModal() {
      if (this.isLoggedIn) {
        this.showSelectDesignModal = true
      } else {
        this.showRequestLoginModal = true
      }
    },
    openAddNewImageModal() {
      this.showAddNewImageModal = true
    },
    deleteDesign(removedDesignUuid: string) {
      const removedDesignIdx = this.userDesigns.findIndex(
        item => item.uuid === removedDesignUuid
      )
      this.selectedDesignImage = this.userDesigns[removedDesignIdx + 1]
      this.userDesigns.splice(removedDesignIdx, 1)
    },
    async onUploadSuccess(data: { uuids: string[], fileExtension: string}) {
      const result = await createUserDesign({
        userUploadImageUuids: data.uuids,
        // @ts-ignore
        fileExtension: data.fileExtension
      }).finally(() => {
        this.showAddNewImageModal = false
        this.trackingAddNewDesignFromSimulator()
      })
      if (result) {
        const userDesign = result.createUserDesign.userDesign
        this.userDesigns.unshift(userDesign)

        if (!this.displayDesignImages.find(
          item => item.uuid === this.selectedDesignImage?.uuid
        )) {
          this.onSelectDesign(userDesign.uuid)
        }
      }
    },
    trackingAddNewDesignFromSimulator() {
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.UPLOAD_AT_SIMULATOR,
        data: {}
      })
      gaEventTracker(EVENT_CATEGORIES.SIMULATOR, EVENT_ACTIONS.UPLOAD, EVENT_LABELS.UPLOAD_AT_SIMULATOR)
    }
  }
})
